import { S3Img, S3ImgProps } from '../s3-img';
import { getMedalsPath } from './get-path';

export const S3MedalsImg = function S3MedalsImg({
  ref,
  s3Key,
  ...rest
}: {
  s3Key?: string;
} & Omit<S3ImgProps, 'path'>) {
  return (
    <S3Img
      ref={ref}
      path={s3Key ? getMedalsPath(s3Key) : undefined}
      {...rest}
    />
  );
};
